import { render, staticRenderFns } from "./orderPending.vue?vue&type=template&id=0125beee&scoped=true&"
import script from "./orderPending.vue?vue&type=script&lang=js&"
export * from "./orderPending.vue?vue&type=script&lang=js&"
import style0 from "./orderPending.vue?vue&type=style&index=0&id=0125beee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0125beee",
  null
  
)

export default component.exports